import React, { useEffect, useState } from "react";
import useMightyMouse from "react-hook-mighty-mouse";
import { motion } from "framer-motion";
import ReactTypingEffect from "react-typing-effect";
// importing other components

//images
import arrowLink from "../images/arrowLink.svg";

// styling
import styled from "styled-components";
import { linkFlex, navFlex } from "../components/GlobalStyle";
import AboutMe from "../components/AboutMe";
import CallToAction from "../components/CallToAction";
import Projects from "../components/Projects";

function Works() {
  // for custom mouse --start
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0,
  });

  const [cursorVariant, setCursorVarient] = useState("default");
  useEffect(() => {
    const customMouseMove = (e) => {
      setMousePosition({
        x: e.clientX,
        y: e.clientY,
      });
    };

    window.addEventListener("mousemove", customMouseMove);

    return () => {
      window.removeEventListener("mousemove", customMouseMove);
    };
  }, []);

  const variants = {
    default: {
      height: 10,
      width: 10,
      x: mousePosition.x - 16,
      y: mousePosition.y - 16,
    },
    text: {
      height: "13vw",
      width: "13vw",
      x: mousePosition.x - 75,
      y: mousePosition.y - 75,
      backgroundColor: "white",
      mixBlendMode: "difference",
    },
  };
  const textEnter = () => setCursorVarient("text");
  const textLeave = () => setCursorVarient("default");
  // for custom mouse --end
  const {
    selectedElement: { isHover },
  } = useMightyMouse(true, "hit-him-up");

  // eye tracking functions --start
  const { position } = useMightyMouse();
  const {
    selectedElement: {
      position: { angle: angleLeftEye },
    },
  } = useMightyMouse(true, "left-eye", { x: 0, y: 0 });
  const {
    selectedElement: {
      position: { angle: angleRightEye },
    },
  } = useMightyMouse(true, "right-eye", { x: 0, y: 0 });

  const rotateLeftEye = `rotate(${-angleLeftEye}deg)`;
  const rotateRightEye = `rotate(${-angleRightEye}deg)`;
  // eye tracking functions --end
  return (
    <WorksStyle>
      {/* navigation bar --start  */}
      <div className="header">
        <motion.div
          initial={{ y: -100 }}
          animate={{ y: 0, zIndex: 1000 }}
          transition={{
            type: "spring",
            stiffness: 400,
            damping: 20,
          }}
          className="navbar"
        >
          <div>samuel a.</div>
          <div className="eyes-block">
            {/* image --start  */}
            {/* eyes --start  */}

            <motion.div
              className="eyes"
              initial={{ y: -100 }}
              animate={{ y: 0 }}
              transition={{
                type: "spring",
                stiffness: 400,
                damping: 20,
                delay: 0.5,
              }}
            >
              <div
                id="right-eye"
                className="eye"
                style={{
                  transform: rotateRightEye,
                  background: isHover ? "black" : "",
                }}
              >
                <div className="iris__right iris"></div>
              </div>
              <div
                id="left-eye"
                className="eye"
                style={{
                  transform: rotateLeftEye,
                  background: isHover ? "black" : "",
                }}
              >
                <div className="iris__left iris"></div>
              </div>
            </motion.div>

            {/* eyes --end  */}
            {/* image --end  */}
          </div>
          <div className="link reduce">
            <a id="hit-him-up" href="mailto:folaborn2013@gmail.com">
              Hit me up
            </a>
            <img src={arrowLink} alt="hit me up" className="hit-image" />
          </div>
        </motion.div>
        {/* navigation bar --end  */}
        {/* header start  */}
        <motion.div
          className="title frontend"
          onMouseEnter={textEnter}
          onMouseLeave={textLeave}
          initial={{ x: "-99vw" }}
          animate={{ x: 0 }}
          transition={{
            type: "spring",
            stiffness: 400,
            mass: 8,
            damping: 20,
            delay: 1,
          }}
        >
          <motion.p
            style={{ textTransform: "uppercase" }}
            whileHover={{
              letterSpacing: "0.4vw",
            }}
            transition={{
              type: "spring",
              stiffness: 400,
              mass: 8,
              damping: 20,
            }}
          >
            SAMUEL
          </motion.p>
        </motion.div>
        <motion.div
          onMouseEnter={textEnter}
          onMouseLeave={textLeave}
          className="title developer"
          initial={{ x: "99vw" }}
          animate={{ x: 0 }}
          transition={{
            type: "spring",
            stiffness: 300,
            mass: 10,
            damping: 20,
            delay: 1,
          }}
        >
          <motion.p
            style={{ textTransform: "uppercase" }}
            whileHover={{
              letterSpacing: "0.4vw",
            }}
            transition={{
              type: "spring",
              stiffness: 400,
              mass: 10,
              damping: 20,
            }}
          >
            AFOLABI
          </motion.p>
        </motion.div>
        <motion.div className="tagline">
          <ReactTypingEffect
            text={[
              " ...creating seamless digital experiences aimed at fulfilling user needs, promoting brands and aggrandizing businesses.",
            ]}
            cursorRenderer={() => <>{}</>}
            typingDelay={2000}
            speed={30}
            eraseSpeed={0}
            eraseDelay={99999999}
            displayTextRenderer={(text, i) => {
              return (
                <>
                  {text.split("").map((char, i) => {
                    const key = `${i}`;
                    return <span key={key}>{char}</span>;
                  })}
                </>
              );
            }}
          />
        </motion.div>
      </div>
      {/* header -- end   */}
      {/* <SelectedWorks textEnter={textEnter} textLeave={textLeave} />   */}
      <Projects textEnter={textEnter} textLeave={textLeave} />
      <AboutMe textEnter={textEnter} textLeave={textLeave} />
      <CallToAction />
      <motion.div
        variants={variants}
        animate={cursorVariant}
        className="cursor"
      />
    </WorksStyle>
  );
}

export default Works;
// styling
export const WorksStyle = styled.div`
  cursor: context-menu;
  font-size: 2.2rem;
  color: #aba89f;
  margin-left: 5px;
 overflow-x: hidden;
  p {
    cursor: ponter;
  }
  .navbar {
    ${navFlex}
    position: fixed; 
    top: 0;
    width: 100%;
    padding: 20px 0;
    background: rgba(18, 18, 18, 0.9);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    z-index: 50;
  }
  @keyframes bg-animation {
    0% {
      background-position: left;
    }
    50% {
      background-position: center;
    }
    100% {
      background-position: left;
    }
  }
  @keyframes bg-animation-2 {
    0% {
      background-position: right;
    }
    50% {
      background-position: center;
    }
    100% {
      background-position: right;
    }
  }
  .title {
    font-size: 14vw;
    font-family: "Monoton", cursive;
    text-transform: lowercase;
    // transition: letter-spacing 0.4s ease-out;
  }
  .frontend {
    margin-top: 40px;
    animation: bg-animation ease-out 5s infinite; 
    background-image: linear-gradient(
      270deg,
      #ffffff -26.42%,
      rgba(255, 255, 255, 0) 159.02%
    );
    background-size: 200%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    text-shadow: 0 0 transparent; 
  }
  .developer {
    margin-top: -6vw;
    animation: bg-animation-2 ease-out 5s infinite; 
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    text-shadow: 0 0 transparent; 
    background-size: 200%;
    background-image: linear-gradient(
      89.86deg,
      #fac72c 3.11%,
      rgba(250, 199, 44, 0) 135.17%
    );
  }
  .tagline {
    font-size: 2vw;
    width: 40vw;
    text-transform: lowercase;
  }
  .link {
    ${linkFlex}
    justify-content: flex-end; y
  }
  .reduce {
    margin-top: -6px;
    text-transform: uppercase;
  }
  .time {
    width: calc(100% / 3);
    text-align: center;
  }
  .eye {
    position: relative;
    height: 2rem;
    width: 2rem;
    background: #710c04;
    border-radius: 50%;
  }
  .eyes {
    display: flex;
    gap: 10px;
    z-index: -1;
  }
  .iris {
    border-radius: 50%;
    position: absolute;
    width: 2rem;
    height: 2rem;
    left: 4px;
    top: 1px;
    // background: white;
    border: 1px solid #cccccc;
    background: radial-gradient(
      39.51% 39.51% at 50% 50%,
      #fac72c 0%,
      rgba(250, 199, 44, 0) 100%
    );
  }
  .cursor {
    background-color: yellow;
    height: 32px;
    width: 32px;
    border-radius: 50%;
    position: fixed;
    top: 0;
    left: 0;
    pointer-events: none;
  }
  .selected {
    font-family: "Monoton", cursive;
    font-size: 5vw;
    color: #232323;
    text-align: right;
    margin-top: 6rem;
  }
  @media only screen and (max-width: 600px) {
    .hit-image {
      width: 2rem;
      margin-right: 5px;
    }
    .eyes-block {
      display: none;
    }
    .header {
      font-size: 1.6rem;
      padding: 1rem 0;
      width: 100vw !important;
    }
    .tagline {
      font-size: 1.6rem;
      width: 80vw;
    }
    .frontend {
      margin-top: 4rem;
    }
    .developer {
      margin-top: -2rem;
    }
    .selected {
      margin: 3rem 0 1rem 0;
    }
  }
`;
